module.exports = __webpack_public_path__ + "static/media/pruef01.f04399dc.jpeg";